<template>
  <div class="height100 d-flex justify-center align-center">
    <div></div>
  </div>
</template>
<script>
export default {
  name: "PaymentError",
  mounted() {
    let paymentData = localStorage.getItem("paymentData")
      ? JSON.parse(localStorage.getItem("paymentData"))
      : null;

    if (paymentData) {
      paymentData.status = "error";
      localStorage.setItem("paymentData", JSON.stringify(paymentData));
      window.location.replace(paymentData.url);
    }
  },
};
</script>
